<template>
  <!--  <?xml version="1.0" encoding="utf-8"?>-->
  <!-- Generator: Adobe Illustrator 26.5.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1200 1200" style="enable-background:new 0 0 1200 1200;" xml:space="preserve">
    <linearGradient id="PIN_LINEAR_GRADIENT" gradientUnits="userSpaceOnUse" x1="207" y1="916.5" x2="1144.5" y2="193">
      <stop  offset="0" :style="{ stopColor: startColor }"/>
      <stop  offset="1" :style="{ stopColor: endColor }"/>
    </linearGradient>
    <path id="PIN_LINEAR_GRADIENT_PATH" style="fill:url(#PIN_LINEAR_GRADIENT);" d="M601.61,58.42c-218.6,1.05-395.6,179.75-394.56,398.36c1.3,271.3,358,667.88,373.18,684.63c14.27,15.74,39.04,15.59,53.13-0.26c15.03-16.89,367.91-416.87,366.62-688.17C998.92,234.38,820.22,57.38,601.61,58.42zM605.71,941.29C494.5,807.07,360.5,603.91,359.89,477.48c-0.64-134.4,108.16-244.26,242.55-244.9c134.4-0.64,244.24,108.17,244.89,242.57C847.99,612.17,699.15,825.6,605.71,941.29z"/>
    <linearGradient id="CIRCLE_LINEAR_GRADIENT" gradientUnits="userSpaceOnUse" x1="207" y1="916.5" x2="1144.5" y2="193">
      <stop  offset="0" :style="{ stopColor: startColor }"/>
      <stop  offset="1" :style="{ stopColor: endColor }"/>
    </linearGradient>
    <path id="CIRCLE_LINEAR_GRADIENT_PATH" style="fill:url(#CIRCLE_LINEAR_GRADIENT);" d="M604.16,337.05c-81.86,0-148.22,66.36-148.22,148.21c0,81.86,66.36,148.22,148.22,148.22s148.21-66.36,148.21-148.22C752.38,403.41,686.02,337.05,604.16,337.05z"/>
</svg>

</template>

<script>
export default {
  name: 'RBHPin',
  props: {
    startColor: {
      type: String,
      default: '#4F2978',
    },
    endColor: {
      type: String,
      default: '#C1187A',
    },
    degree: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    y2Percent() {
      return `${this.degree}%`;
    },
  },
};
</script>

<style scoped>

</style>
